enum ActionTypes {
    GET_PROJECT_AI_ORGANIZE_RESULT = "projectAIOrganize/get",
    GET_PROJECT_AI_ORGANIZE_RESULT_SUCCESS = "projectAIOrganize/getSuccess",
    GET_PROJECT_AI_ORGANIZE_RESULT_FINISH = "projectAIOrganize/getFinish",
    GET_PROJECT_AI_ORGANIZE_RESULT_FAILURE = "projectAIOrganize/getFailure",

    UPDATE_PROJECT_AI_ORGANIZE_RESULT = "projectAIOrganize/update",

    ACCEPT_PROJECT_AI_ORGANIZE_SECTION = "projectAIOrganize/acceptSection",
    REJECT_PROJECT_AI_ORGANIZE_SECTION = "projectAIOrganize/rejectSection",

    CREATE_PROJECT_AI_ORGANIZE = "projectAIOrganize/create",
    CREATE_PROJECT_AI_ORGANIZE_SUCCESS = "projectAIOrganize/createSuccess",
    CREATE_PROJECT_AI_ORGANIZE_FAILURE = "projectAIOrganize/createFailure",

    APPLY_PROJECT_AI_ORGANIZE = "projectAIOrganize/apply",
    APPLY_PROJECT_AI_ORGANIZE_SUCCESS = "projectAIOrganize/applySuccess",
    APPLY_PROJECT_AI_ORGANIZE_FAILURE = "projectAIOrganize/applyFailure",

    CANCEL_PROJECT_AI_ORGANIZE = "projectAIOrganize/cancel",
    CANCEL_PROJECT_AI_ORGANIZE_SUCCESS = "projectAIOrganize/cancelSuccess",
    CANCEL_PROJECT_AI_ORGANIZE_FAILURE = "projectAIOrganize/cancelFailure",

    ADD_PROJECT_AI_ORGANIZE_SECTION = "projectAIOrganize/addSection",

    UPDATE_PROJECT_AI_ORGANIZE_SECTION = "projectAIOrganize/updateSection",

    UPDATE_PROJECT_AI_ORGANIZE_SECTION_ORDER = "projectAIOrganize/updateSectionOrder",

    UPDATE_PROJECT_AI_ORGANIZE_SECTION_SCREEN_ORDER = "projectAIOrganize/updateSectionScreenOrder",

    PROJECT_AI_ORGANIZE_SET_AS_VARIANT = "projectAIOrganize/setAsVariant",

    DELETE_PROJECT_AI_ORGANIZE_SECTION = "projectAIOrganize/deleteSection"
}

export default ActionTypes;
